import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { evaluarEstadoBadge, capitalizeFirstLetter } from '../../utils/funciones';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { Celda, CeldaHeader } from '../../cambios-contractuales/solicitudes-en-curso/useSolicitudesCurso';

export const getColumnas = (objStyleCol, verDetalleLog) => ({
    temporis: [
        {
            name: <CeldaHeader label="ID" alineacion="center" />,
            selector: row => row.id,
            width: '80px',
            style: objStyleCol
        },
        {
            name: 'Administrador Solicitante',
            cell: row => <Celda label={capitalizeFirstLetter(row.user_creator_name)} ancho="500px" />,
            width: '500px',
            style: objStyleCol
        },
        {
            name: <CeldaHeader label="Estado" alineacion="center" />,
            selector: row => evaluarEstadoBadge(row.status),
            wrap: true,
            style: objStyleCol,
            width: '100px',
        },
        {
            name: 'Mensaje emitido por Temporis',
            cell: row => <Celda label={row.resp_clean_temporis} ancho="600px" />,
            width: '600px',
            style: objStyleCol
        },
        {
            name: <CeldaHeader label="Creado" alineacion="center" />,
            selector: row => row.created_at,
            width: '170px',
            style: objStyleCol
        },
        {
            name: 'Acciones',
            wrap: true,
            width: '95px',
            button: true,
            style: objStyleCol,
            cell: (row) => {
                return (
                    <div className='d-flex w-100 justify-content-center'>
                        <button
                            className="btn btnAccion btn-primary btn-sm"
                            data-bs-toggle="tooltip" title="Ver detalle"
                            onClick={() => {
                                // console.log(row);
                                verDetalleLog(row)
                            }}
                        >
                            <FontAwesomeIcon icon={faEye} title='Ver detalle' />
                        </button>
                    </div>
                )
            }
        }
    ]
})


